import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=6536490a"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Sku.vue?vue&type=style&index=0&id=6536490a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "e1a7bc2c"
  
)

export default component.exports